/** Common validation errors */
export enum validTypeEntered {
  LETTERS = "Buchstaben",
  NUMBERS = "Zahlen",
}

export const VALIDATION_ERRORS = {
  inputRequired: (fieldValue: string) => `Bitte füllen Sie das Pflichtfeld ${fieldValue} aus.`,
  selectionRequired: (fieldValue: string) => `Bitte füllen Sie das Pflichtfeld ${fieldValue} aus.`,
  enterValidDate: 'Bitte geben Sie ein gültiges Format an (z.B. "01.01.1990").',
  enterPastDate: "Bitte wählen Sie ein Datum in der Vergangenheit.",
  enterFutureDate: "Das anzugebende Datum muss in der Zukunft liegen.",
  doNotEnterFutureDate: "Das angegebene Datum darf nicht in der Zukunft liegen.",
  ibanInvalid: "Bitte geben Sie eine gültige IBAN an.",
  valueInvalid: "Bitte geben Sie nur gültige Zeichen an.",
  sepaInvalid: "Sie müssen das SEPA-Lastschriftmandat erteilen.",
  max: (maxValue: number) => `Sie haben die maximale Anzahl an Zeichen (${maxValue}) überschritten.`,
  maxWithoutDetails: "Sie haben die maximale Anzahl an Zeichen überschritten.",
  minWithoutDetails: "Bitte geben Sie die Mindestanzahl an Zeichen an.",
  tooFarInThePast: "Das Datum darf nicht mehr als 50 Jahre zurück liegen.",
  doNotEnterLeftZeros: "Bitte geben Sie die Nummer ohne führende Nullen ein.",
  downPaymentError: "Bitte geben Sie die Anzahlung in vollen Euro-Beträgen an. Bitte beachten Sie zudem, dass die Eingabe nur in Ziffern möglich ist.",
  creditEndDate: (creditEndDate: string) => `Die Laufzeit ist bereits abgelaufen (${creditEndDate}). Bitte entfernen Sie diesen Vertrag.`,
};
